import pdf from "../assets/TEXTOS_TEATRALS.pdf#toolbar=0";

const SVTextosTeatralsPage = ({ usuario }) => {
  return (
    <>
      {usuario.isSubscriptionActive && (
        <iframe
          src={pdf}
          width="100%"
          height="800px"
          title="pdfTextosTeatrals"
        />
      )}
    </>
  );
};

export default SVTextosTeatralsPage;
